<template>
    <div>
        <home></home>
        <div class="pagerc">
            <div class="headerimg">
                <img class="pcshow" src="../assets/images/spon.jpg" alt="">
                <img class="mshow" src="../assets/images/mspon.png" alt="">
                <div class="title">
                    <div class="titlep">
                        <h3>赞助参展</h3>
                        <h4>SPONSORSHIP</h4>
                    </div>
                </div>
            </div>
            <div class="inchild clear">
                <div class="wrapleft">
                    <div class="mspon mshow">
                        <h6>主办方</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/logobk.svg" alt=""></a></li>
                        </ul>
                        <h6>协办方</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="http://static.hrflag.com/img/spon/ddi-logo.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="http://hrflag.com/img/zqlogogr.svg" alt=""></a></li>
                        </ul>
                        <h6>学术支持机构</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="http://edm.hrflag.com/imgs/lalogo.jpg" alt=""></a></li>
                        </ul>
                        <h6>智力支持</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/cho100.png" alt=""></a></li>
                        </ul>
                        <h6>独家笔记支持</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/biji.svg" alt=""></a></li>
                        </ul>
                        <h6>媒体支持</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="http://static.hrflag.com/logo/pxzz.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/GHRlogo.jpg" alt=""></a></li>
                        </ul>
                        <h6>赞助机构</h6>
                        <ul>
                            <li><a href="javascript:;"><img src="../assets/images/weir.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/cubiks.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/gml.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/liepin.png" alt=""></a></li>
                            <li><a href="javascript:;"><img src="../assets/images/sea.png" alt=""></a></li>
                            <li><a href="javascript:;"></a></li>
                        </ul>
                    </div>
                    <h2>多元化赞助解决方案</h2>
                    <div class="sponbox">
                        <div class="sponqy">
                            <h6>标准展位赞助  RMB 60,000</h6>
                            <ul>
                                <li>公司名称和Logo列于会议官网进行品牌宣传</li>
                                <li>公司logo列于会议主背景板进行品牌宣传</li>
                                <li>现场配置LED显示屏（40寸）循环播放公司宣传视频</li>
                                <li>获赠2张工作人员门票（含餐，价值RMB10,400）</li>
                                <li>享受会议现场标准展台（1个）</li>
                                <li>赞助企业员工参会门票可享9折优惠</li>
                                <li>入袋资料一份（10P内）</li>
                                <li>会刊1P四色广告</li>
                            </ul>
                        </div>
                         <div class="sponqy">
                            <h6>茶歇赞助 RMB 40,000</h6>
                            <ul>
                                <li>公司名称和Logo列于会议官网进行品牌宣传</li>
                                <li>公司logo列于会议主背景板进行品牌宣传</li>
                                <li>公司logo三脚架在会议茶歇时段呈列于茶歇区及茶饮区</li>
                            </ul>
                        </div>
                    </div>
                    <div class="sponbox">
                        <div class="sponqy">
                            <h6>礼品赞助 RMB 30,000</h6>
                            <ul>
                                <li>公司名称和Logo列于会议官网进行品牌宣传</li>
                                <li>公司logo列于会议主背景板进行品牌宣传</li>
                                <li>赞助礼品展示贵公司logo以及会议logo</li>
                            </ul>
                        </div>
                        <div class="sponqy">
                            <h6>书籍或杂志展示赞助 RMB 10,000/本</h6>
                            <ul>
                                <li>公司名称和Logo列于会议官网进行品牌宣传</li>
                                <li>公司logo列于会议主背景板进行品牌宣传</li>
                                <li>现场陈列评鉴书籍并展示出品公司logo</li>
                                <li>展示书籍通过邮件进行宣传及推广</li>
                                <li>参会来宾可现场购买宣传书籍</li>
                                <li>公司可安排少量书籍签售会（签售数量不超过50本）</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <wrapleft></wrapleft>
            </div>
        </div>
        <foots></foots>
    </div>
</template>

<script>
import home from '@/components/commn/home'
  import foots from '@/components/commn/foots'
  import wrapleft from '@/components/commn/wrapleft'
 export default {
      components:{
        home,
        foots,
        wrapleft
      },
         metaInfo: {
            title: '赞助参展-第42届全球人才评鉴高峰会暨领导人才发展论坛',
            meta: [
            {
                name: 'keywords',
                content: '第42届全球人才评鉴高峰会，领导人才发展论坛'
            },
            {
                name: 'description',
                content: '第42届全球人才评鉴高峰会暨领导人才发展论坛提供多元化赞助商解决方案，包括标准展位赞助、茶歇赞助、礼品赞助、书籍或杂志展示赞助'
            }
            ]
        },
}
</script>

<style scoped>
 @import url('../assets/css/inpublic.css');
</style>



// WEBPACK FOOTER //
// src/components/spon.vue